export function MitIdIcon(props) {
    return(
      <img src="/MitID.svg" style={{width:40}} alt="MitID"/>
        )
}